import React, { useMemo, useState } from "react";
import "./dummy.css";
import { ConfigCells } from "./ConfigCells";
export const BatteryCells = ({ num_cols, isConfig, cellImage, totalCells, sohData }) => {
  const [modules, setModules] = useState({});
  const placeholders = useMemo(() => {
    if(totalCells === 0){
      return [];
    }
    if(isNaN(totalCells)){
      return [];
    }
    const arr = new Array(totalCells);
    for (let i = 0; i < totalCells; i++) {
      arr[i] = "placeholder";
    }
    return arr;
  });

  placeholders && placeholders.length > 0 && placeholders.forEach((_, index) => {
    const colIndex = (index % num_cols) + 1;
    if (!modules[`module${colIndex}`]) {
      modules[`module${colIndex}`] = [];
    }
    modules[`module${colIndex}`].push(index);
  });

  return (
    <div id="btryConfig" className="flex flex-col justify-center items-center w-full">
      <div className="flex flex-row justify-between min-w-[90%] ">
        <div className="col-auto mr-auto cellEndCol1 w-8 max-xsm:w-4 text-[#000]">
          <h3>+</h3>
        </div>
        <div className="col-auto ml-auto cellEndCol2 w-8 max-xsm:w-4 text-[#000]">
          <h2>-</h2>
        </div>
      </div>
      <div className="col-sm-auto fixed_window bg-[black]">
        <div
          className="grid-container grid"
          style={{
            gridTemplateColumns: `repeat(${num_cols.toString()}, 1fr)`,
            ...(isConfig ? {} : { gridTemplateRows: `30px repeat(auto-fill, minmax(30px, auto))` }),
          }}
        >
          {[...Array(num_cols)].map((_, index) => (
            <>
              {!isConfig && (
                <div key={`header-${index}`} className="col-header">
                  Module {index + 1}
                </div>
              )}
            </>
          ))}
          {placeholders.map((_, index) => (
            <ConfigCells
              isConfig={isConfig}
              cellImage={cellImage}
              key={index}
              row={Math.floor(index / num_cols)}
              col={index % num_cols}
              numCols={num_cols}
              numRows={Math.ceil(totalCells / num_cols)}
              cellId={index}
              sohData={sohData}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
